import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { StrictValuePipe } from 'src/app/shared/pipes/strict-value.pipe';
import { TranslationMessagesPipe } from 'src/app/shared/pipes/translation-msg.pipe';
import { IHeaderModel } from './models/header.model';
import { TableItemHelper } from './table-item.helper';
import { ColumnAlignment } from './models/column-alignment.enum';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
})
export class TableComponent implements OnInit, OnChanges {
  @Input() headers?: Array<IHeaderModel>;
  @Input() items?: Array<any>;
  @Input() prefix?: string;
  @Input() enableCheckbox?: boolean;
  @Input() totalItems?: number;
  @Input() enablePagination? = true;
  @Input() showBorder? = true;
  @Input() showTitle? = true;
  @Input() showItemsPerPage? = true;
  @Input() rowSelectable? = false;

  @Output() changePage = new EventEmitter<any>();
  @Output() rowSelected = new EventEmitter<any>();

  page = 1;
  pageSize = 10;
  pageSizes = [10, 25, 50, 100];
  isLoading?: boolean;
  showTable?: boolean;
  alignment = ColumnAlignment;

  constructor(
    private msgPipe: TranslationMessagesPipe,
    private strictValuePipe: StrictValuePipe
  ) {}

  ngOnChanges(): void {
    this.isLoading = true;
    this.showTable = false;
    if (this.items) {
      this.isLoading = false;
      if (this.items.length !== 0) {
        this.showTable = true;
      }
    }
  }

  ngOnInit(): void {
    if (this.enableCheckbox) {
      this.items?.map((obj) => {
        obj.checked = false;
        return obj;
      });
    }
  }

  getSelectedOptions(): any {
    return this.items?.filter((item) => item.checked).map((item) => item);
  }

  getKey(key: string): string {
    return this.msgPipe.transformInstant(this.prefix + key);
  }

  handlePageChange(event: number): void {
    this.page = event;
    this.changePage.emit({ page: this.page, pageSize: this.pageSize });
  }

  handlePageSizeChange(event: any): void {
    this.pageSize = event.target.value;
    this.page = 1;
    this.changePage.emit({ page: this.page, pageSize: this.pageSize });
  }

  selectRow(item: any): void {
    this.rowSelected.emit(item);
  }

  resetPagination(): void {
    this.page = 1;
  }
}
